// MealPlanPromotion is ambient (types/hotel-detail/services/rooms.d.ts).

export type GroupedPromotion = {
  // Type of the first promotion in the group — keeps ids derived from it stable
  // (e.g. the Evo info modal's `promotion-modal-${type}`).
  type: string;
  label: string;
  // Distinct non-empty descriptions, in order of first appearance.
  descriptions: string[];
};

// Groups are returned sorted alphabetically by label: suppliers order promotions differently per
// rate, and a stable order avoids the labels jumping around when switching between rates.

// Suppliers send a standard label per promotion code, so unrelated promotions can share the same
// label with different descriptions (e.g. two "Added value" entries). Each label must render only
// once while keeping every description, so consumers group before rendering (MPH-719).
export function groupPromotionsByLabel(promotions: MealPlanPromotion[] | undefined): GroupedPromotion[] {
  const groupsByLabel = new Map<string, GroupedPromotion>();

  (promotions ?? []).forEach((promotion) => {
    const group = groupsByLabel.get(promotion.label) ?? {
      type: promotion.type,
      label: promotion.label,
      descriptions: [],
    };

    if (promotion.description && !group.descriptions.includes(promotion.description)) {
      group.descriptions.push(promotion.description);
    }

    groupsByLabel.set(promotion.label, group);
  });

  return [...groupsByLabel.values()].sort((a, b) => a.label.localeCompare(b.label));
}
